import { z } from 'zod'
import { isoDateTime, uuid } from './common.js'

export const commentSubject = z.enum(['trip', 'day', 'place', 'reservation'])
export type CommentSubject = z.infer<typeof commentSubject>

/**
 * What a caller may say when adding a comment.
 *
 * Note what is absent: no author field of any kind. On the advisor path the
 * author is the session; on the traveller path it is the participant the link
 * was issued to. Neither is ever taken from the request body, which is why
 * there is nowhere here to put one.
 */
export const createCommentRequest = z.object({
  subjectType: commentSubject,
  subjectId: uuid,
  body: z.string().trim().min(1).max(4000),
})
export type CreateCommentRequest = z.infer<typeof createCommentRequest>

export const comment = z.object({
  id: uuid,
  tripId: uuid,
  subjectType: commentSubject,
  subjectId: uuid,
  /** Exactly one of these is set. The other tells you which side wrote it. */
  authorParticipantId: uuid.nullable(),
  authorUserId: uuid.nullable(),
  /** Resolved for display. The advisor set it; nobody self-names. */
  authorName: z.string(),
  body: z.string(),
  createdAt: isoDateTime,
})
export type Comment = z.infer<typeof comment>
